export default __webpack_public_path__ + "static/media/black.30452e60.svg";